import Abstract from "../../../abstract-view/abstract.js";

export default class Actions extends Abstract {
  constructor(element) {
    super();

    this._element = element;
    this._viewTypesElement = null;
    this._sortingButtons = null;
    this._sortingForm = null;
  }

  getViewTypesElement() {
    if (!this._viewTypesElement) {
      this._viewTypesElement = this._element.querySelector(`.views-list`);
    }

    return this._viewTypesElement;
  }

  getSortingButtons() {
    if (!this._sortingButtons) {
      this._sortingButtons = this._element.querySelectorAll(`.sorting-list__button`);
    }

    return this._sortingButtons;
  }

  getSortingForm() {
    if (!this._sortingForm) {
      this._sortingForm = this._element.querySelector(`.sorting-form`);
    }

    return this._sortingForm;
  }
}
